// extracted by mini-css-extract-plugin
export var mt0 = "fp-7D";
export var mt1 = "fp-8D";
export var mt2 = "fp-9D";
export var mt3 = "fp-aE";
export var mt4 = "fp-bE";
export var mt5 = "fp-cE";
export var mt6 = "fp-dE";
export var promoBanner = "fp-eE";
export var promoBanner__closeBtn = "fp-fE";
export var promoBanner__closeBtn__icon = "fp-gE";
export var promoBanner__content = "fp-hE";
export var promoBanner__content__body = "fp-iE";